import React, { useEffect } from 'react';
import { useLayout } from '../../LayoutContext';
import { EndStyle } from './formsStyle';
import endImg from '../../components/assets/obrigado.webp';
import Header from '../../components/header/Header';
import imageSource from '../../components/assets/obrigado.webp';
import { useNavigate } from 'react-router-dom';
import FooterSend from '../../components/footer/FooterSend';
import videoSource from '../../components/assets/Video_forms.mp4';

const FormEnd = () => {
  const navigate = useNavigate();

  const { setLayoutConfig } = useLayout(); // Usa o hook para acessar a função de configuração

  useEffect(() => {
    // Configura a cor de fundo e o conteúdo do cabeçalho específicos para HomePage
    setLayoutConfig({
      backgroundColor: '#00022D',
      headerContent: {
        // Defina aqui os dados específicos do cabeçalho para a HomePage
      },
    });
  }, [setLayoutConfig]);

  // Função para voltar à primeira página do formulário
  const handleFinish = () => {
    window.location.href = 'https://prideconsultoria.com.br/omint/';
    sessionStorage.clear();
  };

  // Função para ir à página de prévia da simulação
  const handlePreview = () => {
    navigate('/simulacao/11');
  };

  return (
    <>
      <EndStyle>
        <section className="formEnd__wrapper col-12">
          <div className="container col-12">
            <h1 className="title-end">
              Obrigado,
              <br></br>
              Recebemos seu contato!
            </h1>
            {/* Adiciona os botões */}
            <div className="buttons__wrapper">
              <button className="button_link" onClick={handleFinish}>
                Finalizar
              </button>
            </div>
          </div>

          {/* <div className="img__wrapper">
            <img src={endImg} alt="Obrigado" />
          </div> */}
        </section>
        <FooterSend />
      </EndStyle>
    </>
  );
};

export default FormEnd;
